<script setup>
import WrOnboarding from "~/components/global/WrOnboarding.vue";
import onboarding from "./onboarding.json";

const meta_tags = onboarding.meta_tags;

definePageMeta({
  layout: "laravel-layout",
});

useHead({
  title: meta_tags.title,
  meta: meta_tags.meta,
});
</script>

<template>
  <section class="text-center py10 px-4">
    <div class="max-w-screen-xl mx-auto px-4 lg:pt-10 lg:pb-16">
      <h1 class="font-bold">
        <WrGradientText> Our Onboarding Process Is Painless. </WrGradientText>
      </h1>
      <p class="text-lg tracking-[0.5px]">
        We’ll walk you through everything step-by-step to make sure you’re set
        up and ready to go in half the time as before.
      </p>
    </div>
  </section>
  <WrOnboarding :onboarding="onboarding.onboarding" />

  <section class="relative z-10 py-8">
    <div class="max-w-screen-xl mx-auto px-4">
      <h2 class="text-center">
        <WrGradientText text="Trusted for excellence and efficiency" />
        <p class="text-lg text-[var(--foreground)]">
          Webreinvent is trusted by leading organisations to enhance their
          development and operational efficiency.
        </p>
      </h2>
      <WrTestimonialCardCarousel class="mt-12" />
      <WrButton link="/testimonials" container-class="max-w-max mx-auto mt-7"
        >View All</WrButton
      >
    </div>
  </section>
</template>
